import React from 'react';
import { BoxFeedBackImagem } from '../LeadBox/Fechado/fechado-styled';
import Image from 'next/image';
import { ErroEnvioSVG, SucessoEnvioSVG } from '../../utils/icons';
import { FeedbackContainer } from './feedback-styled';

const Feedback = (props) => {
    return (
        <>
            <FeedbackContainer>
                {props.success ? (
                    <>
                        <BoxFeedBackImagem>
                            <Image
                                alt="sucesso ao enviar"
                                src={SucessoEnvioSVG}
                                width={100}
                                height={100}
                            />
                        </BoxFeedBackImagem>
                        <h2>Enviado!</h2>
                    </>
                ) : (
                    <>
                        <BoxFeedBackImagem>
                            <Image
                                alt="erro ao enviar"
                                src={ErroEnvioSVG}
                                width={100}
                                height={100}
                            />
                        </BoxFeedBackImagem>
                        <h2>Erro ao enviar!</h2>
                    </>
                )}
            </FeedbackContainer>
        </>
    );
};

export default Feedback;
